/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Duplicate_ButtonInputs */

const en_company_jobs_duplicate_button = /** @type {(inputs: Company_Jobs_Duplicate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate`)
};

const de_company_jobs_duplicate_button = /** @type {(inputs: Company_Jobs_Duplicate_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplizieren`)
};

/**
* | output |
* | --- |
* | "Duplicate" |
*
* @param {Company_Jobs_Duplicate_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_duplicate_button = /** @type {((inputs?: Company_Jobs_Duplicate_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Duplicate_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_duplicate_button(inputs)
	return en_company_jobs_duplicate_button(inputs)
});